import { __assign } from "tslib";
import { createHttpTestKit } from './../http/test-kit';
import { createFakeGetResponder, createFakePostResponder } from './../test-utils';
import { createBrandsApi } from '.';
export var createBrandsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createBrandsApi('', fakeHttp);
    var brandsRelativePath = '/brand';
    var brandsUriUrl = function (id) { return brandsRelativePath + "/" + id; };
    var testKit = {
        whenGetAllBrands: function (enabled) {
            return createFakeGetResponder(fakeHttp, "" + brandsRelativePath + (enabled ? "?enabled=true" : ''));
        },
        whenGetBrand: function (dto) {
            return createFakeGetResponder(fakeHttp, brandsUriUrl(dto.id));
        },
        whenAddBrand: function (dto) {
            return createFakePostResponder(fakeHttp, brandsRelativePath)(dto);
        },
        whenUpdateBrand: function (dto) {
            return createFakePostResponder(fakeHttp, brandsUriUrl(dto.id) + "/update")({ name: dto.name, logoUrl: dto.logoUrl });
        },
        whenEnableBrand: function (dto) {
            return createFakePostResponder(fakeHttp, brandsUriUrl(dto.id) + "/enable")({});
        },
        whenDisableBrand: function (dto) {
            return createFakePostResponder(fakeHttp, brandsUriUrl(dto.id) + "/disable")({});
        },
        whenIsSubdomainAvailable: function (name) {
            return createFakePostResponder(fakeHttp, brandsRelativePath + "/nameAvailable")(name);
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map